import { createContext } from 'react'

const GovernanceProjectNameDpoContext = createContext()

export default GovernanceProjectNameDpoContext
